export function createFilterMode(storageKey, validModes = ['only', 'visible']) {
  return {
    getStored(defaultMode = 'visible') {
      if (typeof window === 'undefined') return defaultMode
      const stored = window.localStorage.getItem(storageKey)
      return validModes.includes(stored) ? stored : defaultMode
    },
    persist(mode) {
      if (typeof window === 'undefined') return
      try { window.localStorage.setItem(storageKey, mode) } catch {}
    },
  }
}

export function createSortPref(storageKey) {
  return {
    getStored(defaultValue = []) {
      if (typeof window === 'undefined') return defaultValue
      try {
        const stored = JSON.parse(window.localStorage.getItem(storageKey))
        if (!Array.isArray(stored) || !stored.every(c => c && typeof c.key === 'string' && (c.dir === 1 || c.dir === -1))) {
          return defaultValue
        }
        return stored
      } catch {
        return defaultValue
      }
    },
    persist(columns) {
      if (typeof window === 'undefined') return
      try { window.localStorage.setItem(storageKey, JSON.stringify(columns)) } catch {}
    },
  }
}

export function createPageSizePref(storageKey) {
  return {
    getStored(defaultValue = 30) {
      if (typeof window === 'undefined') return defaultValue
      const stored = Number(window.localStorage.getItem(storageKey))
      if (!Number.isInteger(stored) || stored <= 0) return defaultValue
      return stored
    },
    persist(size) {
      if (typeof window === 'undefined') return
      try { window.localStorage.setItem(storageKey, String(size)) } catch {}
    },
  }
}
